// extracted by css-extract-rspack-plugin
export default {"modalFooter":"jlPz2C_yIowtR5YN","subtitleIntro":"dqeqt1epjwJAa2yM"};